// Localized storefront display.
import { useStoreLanguage } from '@/i18n';

import { Suspense } from 'react';
import { Outlet, useLocation } from '@/i18n/router';
import Navbar from '../feature/Navbar';
import Footer from '../feature/Footer';
import CartDrawer from '../feature/CartDrawer';
import WishlistDrawer from '../feature/WishlistDrawer';
import CookieConsent from '../feature/CookieConsent';

/**
 * Páginas que gestionan su propio offset respecto a la navbar fija
 * (hero fullscreen, etc.) y NO necesitan el padding-top global.
 */
const NO_OFFSET_PATHS = ['/'];

const MainLayout = () => {
  useStoreLanguage();
  const location = useLocation();
  const needsOffset = !NO_OFFSET_PATHS.includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      {/*
        Navbar fija: TopBarStrip h-8 (32px) + barra nav h-16/h-[72px]
        Total: 96px móvil / 104px desktop.
        Las páginas que no son home necesitan este offset para no quedar tapadas.
      */}
      <div className={`flex-1 flex flex-col ${needsOffset ? 'pt-[104px]' : ''}`}>
        <Suspense
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-forest-600"></div>
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
      <Footer />
      <CartDrawer />
      <WishlistDrawer />
      <CookieConsent />
    </div>
  );
};

export default MainLayout;
